<template>
    <div v-if="discounts.hasOwnProperty(cartItem.id)">
        <div
            v-for="discount in discounts[cartItem.id]"
            :key="discount.id"
            class="px-4 py-2 text-gray-700 text-sm sm:text-base flex items-center"
        >
            <CheckIcon class="h-5 w-5 mr-3" aria-hidden="true" />
            <span>
                {{ discount.name }}
            </span>
            <button
                :data-test="`remove-discount-${discount.id}`"
                @click="removeCoupon(discount)"
                v-if="discount.coupon_code"
                type="button"
                class="ml-1 text-red-500 hover:text-red-600 focus:outline-none"
            >
                <LoadingIcon v-if="loading" class="h-4 w-4" />
                <XCircleIcon v-else class="h-4 w-4" aria-hidden="true" />
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { CheckIcon } from "@heroicons/vue/outline";
import { XCircleIcon } from "@heroicons/vue/solid";
import { useCoupon } from "../../functions/useCoupon";
import LoadingIcon from "../LoadingIcon.vue";

defineProps<{
    cartItem?: any;
    discounts?: any;
}>();

const { loading, removeCoupon } = useCoupon();
</script>
